const successIcon = `
    <svg class="directory-success-swal__svg" width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <circle class="directory-success-swal__circle" cx="36" cy="36" r="31" />
        <path class="directory-success-swal__check" d="M22.5 37.5L31.6 46.6L50 27.4" />
    </svg>
`

export function showDirectorySuccess(vm, options = {}) {
    const {
        title = 'Success!',
        description = '',
        timer = 5000,
        showConfirmButton = false,
        showCloseButton = true
    } = options

    return vm.$swal({
        title,
        html: description,
        icon: 'success',
        iconHtml: successIcon,
        buttonsStyling: false,
        showCloseButton,
        showConfirmButton,
        timer: showConfirmButton ? undefined : timer,
        customClass: {
            popup: 'directory-success-swal',
            icon: 'directory-success-swal__icon',
            title: 'directory-success-swal__title',
            htmlContainer: 'directory-success-swal__text',
            closeButton: 'directory-success-swal__close',
            confirmButton: 'directory-success-swal__confirm'
        }
    })
}
